<template>
  <div class="page">
    <Header
      :setting="{
        title: '測試',
        hasCancelMethod: false,
      }"
    />
    <div>
      {{ composable.member }}
    </div>
  </div>
</template>

<script>
import composable from '@/composable/index';

export default {
  setup() {
    return {
      composable,
    };
  },
};
</script>
